// extracted by mini-css-extract-plugin
export var borderRadius = "_fa-4";
export var large = "_fa-3";
export var logoContainer = "_fa-0";
export var nameLogo = "_fa-2";
export var small = "_fa-1";